import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {TableItemObject} from '@PosterWhiteboard/items/table-item/table-item.class';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';

export function useGetKeyFromTableItem<T extends keyof TableItemObject>(key: T): TableItemObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item?.gitype === ITEM_TYPE.TABLE || item?.gitype === ITEM_TYPE.MENU) {
      const itemCopy = item as TableItemObject;
      if (itemCopy?.[key] !== undefined) {
        return itemCopy[key];
      }
    }

    return undefined;
  });
}
